export class Audio {
  playDefault: boolean;

  constructor(
    public name?: string,
    public id?: number,
    public language?: string,
    public url?: string,
  ) {
    this.playDefault = false;
  }

  /**
   * mark current as default
   * @return {Audio}
   */
  setDefaultAudio(): Audio {
    this.playDefault = true;
    return this;
  }
}
